import React, { Component } from "react";

import { default as WSlide } from "@mui/material/Slide";

class Slide extends Component {
  render() {
    return <WSlide {...this.props} />;
  }
}

export default Slide;
